import FlexPane from './_flex-pane.js'
import SelectableButton from './_selectable-button.js'
import SelectedIndicator from './_selected-indicator.js'

export default {
  name: 'SelectableButtonGroup',
  values: {
    disableSelectedButton: true,
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
      },
    },
    selectableButton: {
      configSet: SelectableButton,
      configValues: {},
    },
    showSlidingSelectedIndicator: false,
    slidingSelectedIndicator: {
      configSet: SelectedIndicator,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
